import createGraphqlClient from "@/utils/apollo";

export const fragments = {
	CardDepartment: `
		fragment CardDepartment on DepartmentType {
			id
			name
			code
            parent_id
            can_update
            can_delete
			description
		}
    `,
	CardTitle: `
		fragment CardTitle on TitleType {
			id
			name
            is_lead
            can_update
            can_delete
			description
			role {
				id
				name
			}
			department {
				id
				name
			}

		}
	`,
	CardDetailDepartment: `
		fragment CardDetailDepartment on DepartmentType {
			id
			name
			code
			parent_id
			can_update
			can_delete
			description
			nest_left
			nest_right
			nest_depth
			titles {
				id
				name
				role {
					name
				}
				is_lead
			}
		}
	`
};

export default createGraphqlClient("cmcard");
